import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import * as APITypes from "~/API";

export const ApplicationStatusTag = ({
  status,
}: {
  status: APITypes.ApplicationStatusType | undefined;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = "Submitted"; // TODO: Add to translations

  if (!status) {
    statusText = t("None");
  }

  switch (status) {
    case APITypes.ApplicationStatusType.Approved: {
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Approved");
      break;
    }
    case APITypes.ApplicationStatusType.UnderReview: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = "Under Review"; // TODO: Add to translations
      break;
    }
    case APITypes.ApplicationStatusType.Rejected: {
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Rejected");
      break;
    }
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
